import './Message.css'

export default function Message({ role, text, time, children }) {
  return (
    <div className={`message ${role}`}>
      <div>
        <div className="message-bubble">
          {children || text}
        </div>
        {time && <div className="message-meta">{time}</div>}
      </div>
    </div>
  )
}
